import React, { useEffect, useRef } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Header from './../../compoments/Header'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import MaterialTable, { MTableToolbar } from 'material-table'
import Toolbar from '@material-ui/core/Toolbar';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Autocomplete from '@material-ui/lab/Autocomplete';
import api from './../../services/axios'
import { Redirect } from 'react-router'
import Paper from '@material-ui/core/Paper';
import AlertDialog from './../../compoments/AlertDialog'
import DatePicker from './../../compoments/DatePicker';
import TimePickerCustom from './../../compoments/TimePickerCustom';
import Loading from './../../compoments/Loading'
import MaterialTableComponent from './../../compoments/MaterialTableComponent'
import { baseURL } from './../../env.js'

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
  },
  fixedHeight: {
    height: 240,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: '100%',
  },
}));

export default function MapaAtendimento() {

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };


  function getStyles(name, personName, theme) {
    return {
      fontWeight:
        personName.indexOf(name) === -1
          ? theme.typography.fontWeightRegular
          : theme.typography.fontWeightMedium,
    };
  }

  const role = 'ope';
  const roleName = '';
  const pageTitle = 'Mapa de atendimento';
  const theme = useTheme();
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [columns, setColumns] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [redirect, setRedirect] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [start, setStart] = React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(0)
    dt.setMinutes(0);
    return dt;
  });
  const [filaId, setFilaId] = React.useState('');
  const [userId, setUserId] = React.useState('');
  const [end, setEnd] =React.useState(() => {
    const dt = new Date();
    dt.setDate(dt.getDate())
    dt.setHours(23)
    dt.setMinutes(59);
    return dt;
  });
  const [title, setTitle] = React.useState('');
  const [filas, setFilas] = React.useState([]);
  const [filasSelected, setFilasSelected] = React.useState([]);
  const [operadores, setOperadores] = React.useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [operador, setOperador] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');
  const [startStr, setStartStr] = React.useState('');
  const [endStr, setEndStr] = React.useState('');
  const [urlPdf, setUrlPdf] = React.useState('');
  const [media, setMedia] = React.useState(0);


  const loadFilas = async () => {
    const data = await api.get('/v1/queue-table?order=id&orderType=desc')
    setFilas(data.data.data)
  }
  const loadOperadores = async () => {
    const data = await api.get('/v1/operadores?role=ope')
    setOperadores(data.data.data)
  }

  const loadData = async (a, b) => {
    setLoading(true)
    const dateToString = (date, time, format) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
      const yyyy = date.getFullYear();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      let timeString = '';
      if (time) {

        if(format){
          timeString = ' às ' + hours.toString().padStart(2, '0') + 'h' + minutes.toString().padStart(2, '0');
        }else{
          timeString = ' ' + hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0');
        }
      }
      
      let dtString = format ?  dd + '/' + mm + '/' + yyyy.toString().substr(-2)  :  yyyy + '-' + mm + '-' + dd;
      
      return  dtString + '' + timeString;
    
    }

    const toHHMMSS = function (seconds) {
      // let seconds = parseInt(minutes) * 60;
      // multiply by 1000 because Date() requires miliseconds
      let date = new Date(seconds * 1000);
      let hh = date.getUTCHours();
      let mm = date.getUTCMinutes();
      let ss = date.getSeconds();
      // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
      // if (hh > 12) {hh = hh % 12;}
      // These lines ensure you have two-digits
      if (hh < 10) {hh = "0"+hh;}
      if (mm < 10) {mm = "0"+mm;}
      if (ss < 10) {ss = "0"+ss;}
      // This formats your string to HH:MM:SS
      return hh+":"+mm+":"+ss;
    }

    let url = '/v2/relatorios/mapa-atendimento?start=' + dateToString(a, true) + '&end=' + dateToString(b, true);
    
    if(operador && operador.id){
      url += '&userId='+operador.id;
    }
    
    setStartStr(dateToString(start, true));
    setEndStr(dateToString(end, true));
    setUrlPdf(url);

    const data = await api.get(url)
    console.log('------data.data', data.data)
    setLoading(false)
    let cols = data.data.columns.map((i)=>{
      if(i.field !== 'agent'){
        i.cellStyle = {
          textAlign: 'center',
        };
        i.headerStyle = {
          textAlign: 'center',
        };
      }
      return i;
    });
    // setColumns(cols)
    setColumns(cols)
    setData(data.data.data)
  }

  useEffect(() => {
    loadFilas()
    loadOperadores()
    loadData(start, end)
  }, [])

  const search = () => {
    setTitle('de ' + start + ' até ' + end)
    loadData(start, end)
  }

  const downloadCsv = (data, fileName) => {
    const finalFileName = fileName.endsWith(".csv") ? fileName : `${fileName}.csv`;
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([data], { type: "text/csv" }));
    a.setAttribute("download", finalFileName);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  const tableRef = useRef();


  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      {/* TOPO E MENU DRAWER*/}
      <Header titleHeader={pageTitle} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Typography color="textPrimary">{pageTitle}</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              {loading ? <Loading /> :
                <MaterialTableComponent
                  tableRef={tableRef}
                  components={{
                    Toolbar: props => (
                      <>
                        <Grid container spacing={3} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                          <Grid item xs={3} style={{ alignSelf: 'center' }}>
                            <DatePicker
                              value={start}
                              onChange={setStart}
                              label={'Data'}
                            />
                          </Grid>
                          <Grid item xs={3} style={{ alignSelf: 'center' }}>
                            <TimePickerCustom
                              value={start}
                              onChange={setStart}
                              label={'Hora'}
                            />
                          </Grid>
                          <Grid item xs={3} style={{ alignSelf: 'center' }}>
                            <DatePicker
                              value={end}
                              onChange={setEnd}
                              label={'Até a data'}
                            />
                          </Grid>
                          <Grid item xs={3} style={{ alignSelf: 'center' }}>
                            <TimePickerCustom
                              value={end}
                              onChange={setEnd}
                              label={'Até a Hora'}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={3} style={{ paddingLeft: 20, paddingBottom: 20 }}>
                          <Grid item xs={6} style={{ alignSelf: 'center' }}>
                            <Autocomplete
                              value={operador}
                              onChange={(event, newValue) => {
                                setOperador(newValue);
                              }}
                              id="combo-box-demo"
                              options={operadores}
                              getOptionLabel={(option) => option.cod + ' - ' + option.name}
                              renderInput={(params) => <TextField value={userId} {...params} label="Operador" variant="outlined" />}
                            />
                          </Grid>
                          <Grid item xs={12} style={{ alignSelf: 'center', marginTop: 20 }}>
                            <Button
                              type="button"
                              variant="contained"
                              color="primary"
                              onClick={search}
                            >
                              Gerar
                          </Button>
                          </Grid>
                          <Grid item xs={12} style={{ alignSelf: 'center', 
                            marginTop: 0, 
                            marginBottom: 0, 
                            paddingTop: 0, 
                            paddingBottom: 0, 
                          }}>
                            <MTableToolbar {...props} style={{padding:0, margin:0}} />
                          </Grid>
                        </Grid>
                      </>)
                  }}
                  columns={columns}
                  data={data}
                  title={null}
                  options={{
                    exportButton: {
                      csv: true,
                      pdf: true,
                    },
                    exportCsv: (columns, data) => {
                      const headerRow = columns.map(col => {
                        if (typeof col.title === 'object') {
                          return col.title.props.text;
                        }
                        return col.title;
                      });
                      let dataRows = data.map(({ tableData, ...row }) => {
                        let rowsParse = [];
                        for(let cl in columns){
                          rowsParse[cl] = row[columns[cl].field] || '';
                        }
                        return rowsParse;
                      });
                      const { exportDelimiter } = tableRef.current.props.options;
                      const delimiter = exportDelimiter ? exportDelimiter : ";";
                      const csvContent = [headerRow, ...dataRows].map(e => e.join(delimiter)).join("\n");
                      const ini = startStr.replace(' ', '_').replace(':', '');
                      const end = endStr.replace(' ', '_').replace(':', '');
                      const csvFileName = pageTitle +' - '+ ini + "_ate_" + end;
                      downloadCsv(csvContent, csvFileName);
                    },
                    exportPdf: (columns, data) => {                      
                      const ini = startStr.replace(' ', '_').replace(':', '');
                      const end = endStr.replace(' ', '_').replace(':', '');
                      const namePdf = pageTitle +' - '+ ini + "_ate_" + end + ".pdf&tpl=mapaAtendimento";
                      window.open(baseURL+''+urlPdf+'&media='+media+'&tpl=atendidas&pdf=1&namePdf='+namePdf);
                    }
                  }}
                />
              }
            </Grid>
            <AlertDialog message={message}
              onClose={() => setMessage(false)}
              title={alertTitle}
              buttonSuccessText={'OK'}
            />
          </Grid>
        </Container>
      </main >
    </div >
  );
}